export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_DOWNLOAD_INVOICE = `Account Overview - Click on download invoice`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_HELP_WITH_MY_ORDER = `Account Overview - Click on help with my order`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_LAST_ORDER_DETAIL = `Account Overview - Click on last order detail`

export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_LAST_ORDER_TRACKING = `Account Overview - Click on last order tracking`

export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_OVERVIEW_VIEW_ALL_ORDERS = `Account Overview - Click on view all orders`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_MY_DATA_LINK = `Account Overview - Click on my data section link`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_SERVICES_LINK = `Account Overview - Click on services section link`
export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_HELP_CENTRE_LINK = `Account Overview - Click on help centre section link`

export const EXPERIMENTS_TRACK_EVENT_ACCOUNT_VISITOR = `Account Overview unique visitor`

export const EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK =
  'SERP - Click on product detail link'
export const EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_REFINED_QUERY_CLICK =
  'SERP - Refined query clicked'

export const EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT =
  'PDP - Click add-2-cart MP Product'
export const EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_MP_PRODUCT_WITH_SELLER_PROMOTIONS =
  'PDP - Click add-2-cart MP Product with seller promotions'
export const EXPERIMENTS_TRACK_EVENT_PDP_SHOW_SELLER_MODAL =
  'PDP - Click show seller modal'
export const EXPERIMENTS_TRACK_EVENT_PDP_ADD_TO_CART_CTA =
  'PDP - Click on add-2-cart CTA'
export const EXPERIMENTS_TRACK_EVENT_PDP_CART_DRAWER_GO_TO_CART =
  'PDP - Cart intermediate drawer - Click on go to cart'

export const EXPERIMENTS_TRACK_EVENT_EXIT_INTENT_POPUP_MODAL_CLOSE_MODAL =
  'Exit Intent popup closed'
export const EXPERIMENTS_TRACK_EVENT_EXIT_INTENT_POPUP_MODAL_CLICK =
  'Exit Intent popup clicked'

export const EXPERIMENTS_TRACK_EVENT_ADD_TO_CART_BUTTON =
  'Click on add-to-cart button'
export const EXPERIMENTS_TRACK_EVENT_PDP_DELIVERY_OPTIONS_OTC =
  'PDP - Delivery options - OTC'
export const EXPERIMENTS_TRACK_EVENT_PDP_DELIVERY_OPTIONS_NOW_DELIVERY =
  'PDP - Delivery options - Now delivery'
export const EXPERIMENTS_TRACK_EVENT_PDP_DELIVERY_OPTIONS_NOW_CC =
  'PDP - Delivery options - Now CC'
export const EXPERIMENTS_TRACK_EVENT_PDP_COMPETERA = 'PDP - add to cart'
export const EXPERIMENTS_TRACK_EVENT_SERP_COMPETERA =
  'SERP: Click on product detail link'
export const EXPERIMENTS_TRACK_EVENT_CSW_COMPETERA = 'SLIDER - Click on product'

export const EXPERIMENTS_TRACK_EVENT_NFC_CTA_CLICK = 'NFC LP - CTA click'

export const EXPERIMENT_TRACK_EVENT_OWN_BRANDS_OVERLAY_ADD_TO_CART =
  'Overlay - Click on add-2-cart CTA'
export const EXPERIMENT_TRACK_EVENT_OWN_BRANDS_OVERLAY_CLICK_ON_CLOSE =
  'Overlay - Click on close'
export const EXPERIMENT_TRACK_EVENT_CLICK_ON_CTA =
  'Overlay - Click on CTA button'
export const EXPERIMENT_TRACK_EVENT_OWN_BRANDS_OVERLAY_CLICK_ON_IMAGE =
  'Overlay - Click on image'

export const EXPERIMENTS_TRACK_EVENT_HEADER_MOBILE_ACCOUNT_ICON_LOGGED_IN =
  'HEADER - Click on account icon logged in'

export const EXPERIMENTS_TRACK_EVENT_HEADER_MOBILE_ACCOUNT_ICON_NOT_LOGGED_IN =
  'HEADER - Click on account icon not logged in'

export const EXPERIMENTS_TRACK_EVENT_HEADER_SEARCH_ICON =
  'HEADER - Click on search icon'

export const EXPERIMENTS_TRACK_EVENT_HEADER_SEARCH_INPUT =
  'HEADER - Click on search box'

export const EXPERIMENTS_TRACK_EVENT_HEADER_MOBILE_CART_ICON =
  'HEADER - Click on cart icon'

export const EXPERIMENTS_TRACK_EVENT_HEADER_MOBILE_LOGO =
  'HEADER - Click on logo'

export const EXPERIMENTS_TRACK_EVENT_HEADER_MOBILE_HAMBURGER =
  'HEADER - Click on burger menu'

export const EXPERIMENTS_TRACK_EVENT_HEADER_MOBILE_ACCOUNT_INSIDE_BURGER_LOGGED_IN =
  'HEADER - Click on my account inside burger logged in'

export const EXPERIMENTS_TRACK_EVENT_HEADER_MOBILE_ACCOUNT_INSIDE_BURGER_NOT_LOGGED_IN =
  'HEADER - Click on my account inside burger not logged in'

export const EXPERIMENTS_TRACK_EVENT_PDP_SELLER_PROMOTION_BANNER_IMPRESSION =
  'PDP - Marketplace seller promotion banner impressions'

export const EXPERIMENTS_TRACK_EVENT_REGISTRATION_FORM_SUBMIT =
  'REGISTER_ACCOUNT'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_FIRST_ORDER_CLICK =
  'HC - Clicks on First Order'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_SECOND_ORDER_CLICK =
  'HC - Clicks on Second Order'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_THIRD_ORDER_CLICK =
  'HC - Clicks on Third Order'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_SEEING_ALL_ORDER_CLICK =
  'HC - Clicks on Seeing All Order'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_PAYMENT_CLICK =
  'HC - Clicks on Payment'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_ACCOUNT_MANAGEMENT_CLICK =
  'HC - Clicks on Account Management'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_PHARMA_CLICK =
  'HC - Clicks on Pharma'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_CONTACT_CLICK =
  'HC - Clicks on Contact'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_SEE_ALL_FAQ_CLICK =
  'HC - Clicks on See All FAQ'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_DELIVERY_FAQ_CLICK =
  'HC - Click on Delivery FAQ'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_RETURN_FAQ_CLICK =
  'HC - Click on Return FAQ'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_CANCELATION_FAQ_CLICK =
  'HC - Click on Cancelation FAQ'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_PAYMENT_FAQ_CLICK =
  'HC - Clicks on Payment FAQ'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_DELIVERY_COST_FAQ_CLICK =
  'HC - Clicks on Delivery Cost FAQ'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_VOUCHER_FAQ_CLICK =
  'HC - Clicks on Voucher FAQ'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_TRACK_DELIVERY_SHORTCUT =
  'HC - Clicks on Track Delivery Shortcut'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_CANCEL_ORDER_SHORTCUT =
  'HC - Clicks on Cancel Order Shortcut'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_RETURN_ORDER_SHORTCUT =
  'HC - Clicks on Return Order Shortcut'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_DOCUMENTS_SHORTCUT =
  'HC - Clicks on Order Documents Shortcut'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_PAYMENT_DETAILS_SHORTCUT =
  'HC - Clicks on Payment Details Shortcut'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_OTHERS_SHORTCUT =
  'HC - Clicks on Others Shortcut'

export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_CANCELATION =
  'HC - Click on Cancelation in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_RETURN =
  'HC - Click on Return in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_CHANGE_ORDER =
  'HC - Click on Change Order in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_REPORT_DAMAGED_ORDER =
  'HC - Click on Report Damaged Order in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_TRACK_DELIVERY =
  'HC - Clicks on Track Delivery in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_WRONG_ORDER =
  'HC - Clicks on Wrong Order in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_ORDER_DOCUMENTS =
  'HC - Clicks on Order Documents in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_OTHER_TOPICS =
  'HC - Clicks on Other Topics in Order Detail'
export const EXPERIMENTS_TRACK_EVENT_HELP_CENTER_PAYMENT_INFORMATION =
  'HC - Clicks on Payment Information in Order Detail'
